import * as React from 'react';
import PropTypes from "prop-types";
import {
  Box, Grid,
  Table, TableBody, TableContainer, TableRow
} from "@mui/material";
import {RecipeSummaryTableCell} from "./RecipeTableCell";

function RecipeSummaryTable(props) {
  const {items} = props

  const isEffHydrationDiff = (Math.abs(items.effectiveRecipeHydrationPct - items.recipeHydrationPct) >= 0.5)
  const isEffFlourDiff = (Math.abs(items.effectiveRecipeFlourTotalWeight - items.recipeFlourTotalWeight) >= 0.5)
  const isEffLiquidDiff = (Math.abs(items.effectiveRecipeLiquidTotalWeight - items.recipeLiquidTotalWeight) >= 0.5)
  return (
     <Grid item container direction={'row'} spacing={1} columns={{xs: 4, sm: 8, md: 8}}>
       <Grid item xs={2} sm={4} md={4}>
         <TableContainer>
           <Table size={"small"}>
             <TableBody>
               {items.recipeHydrationPct > 0 ? (
                 <TableRow>
                   <RecipeSummaryTableCell>Hydro</RecipeSummaryTableCell>
                   <RecipeSummaryTableCell align={'right'}>
                     <Box component="span" fontWeight='fontWeightBold'>{items.recipeHydrationPct}%</Box>
                   </RecipeSummaryTableCell>
                 </TableRow>
               ) : null}
               {isEffHydrationDiff ? (
                 <TableRow>
                   <RecipeSummaryTableCell>Eff. Hydro</RecipeSummaryTableCell>
                   <RecipeSummaryTableCell align={'right'}>
                     <Box component="span">{items.effectiveRecipeHydrationPct}%</Box>
                   </RecipeSummaryTableCell>
                 </TableRow>
               ) : null}
               <TableRow>
                 <RecipeSummaryTableCell>Flour</RecipeSummaryTableCell>
                 <RecipeSummaryTableCell align={'right'}>{items.recipeFlourTotalWeight}g</RecipeSummaryTableCell>
               </TableRow>
               <TableRow>
                 <RecipeSummaryTableCell>Liquid</RecipeSummaryTableCell>
                 <RecipeSummaryTableCell align={'right'}>{items.recipeLiquidTotalWeight}g</RecipeSummaryTableCell>
               </TableRow>
               {items.recipeYeastTotalWeight === 0 ? null
                 : (
                     <TableRow>
                       <RecipeSummaryTableCell>Dry Yeast</RecipeSummaryTableCell>
                       <RecipeSummaryTableCell align={'right'}>{items.recipeYeastTotalWeight}g</RecipeSummaryTableCell>
                     </TableRow>
                 )
               }
               {items.recipeStarterTotalWeight === 0 ? null
                 : (
                     <TableRow>
                       <RecipeSummaryTableCell>{items.includePreferment ? 'Starter' : 'Levain'}</RecipeSummaryTableCell>
                       <RecipeSummaryTableCell align={'right'}>{items.recipeStarterTotalWeight}g</RecipeSummaryTableCell>
                     </TableRow>
                 )
               }
               {isEffFlourDiff ? (
                       <TableRow>
                         <RecipeSummaryTableCell>Eff. Flour</RecipeSummaryTableCell>
                         <RecipeSummaryTableCell align={'right'}>{items.effectiveRecipeFlourTotalWeight}g</RecipeSummaryTableCell>
                       </TableRow>
               ) : null}
               {isEffLiquidDiff ? (
                       <TableRow>
                         <RecipeSummaryTableCell>Eff. Liquid</RecipeSummaryTableCell>
                         <RecipeSummaryTableCell align={'right'}>{items.effectiveRecipeLiquidTotalWeight}g</RecipeSummaryTableCell>
                       </TableRow>
               ) : null}
             </TableBody>
           </Table>
         </TableContainer>
       </Grid>
       <Grid item xs={2} sm={4} md={4}>
         <TableContainer>
           <Table size={"small"}>
             <TableBody>
               <TableRow>
                 <RecipeSummaryTableCell>Dough Units</RecipeSummaryTableCell>
                 <RecipeSummaryTableCell align={'right'}>{items.numBatches}</RecipeSummaryTableCell>
               </TableRow>
               <TableRow>
                 <RecipeSummaryTableCell>Unit Weight</RecipeSummaryTableCell>
                 <RecipeSummaryTableCell align={'right'}>{items.recipeUnitWeight}g</RecipeSummaryTableCell>
               </TableRow>
               <TableRow>
                 <RecipeSummaryTableCell>Total Weight</RecipeSummaryTableCell>
                 <RecipeSummaryTableCell align={'right'}>{items.recipeTotalWeight}g</RecipeSummaryTableCell>
               </TableRow>
             </TableBody>
           </Table>
         </TableContainer>
       </Grid>
     </Grid>
    )
}

RecipeSummaryTable.propTypes = {
  items: PropTypes.shape({
    recipeName: PropTypes.string,
    notes: PropTypes.string,
    numBatches: PropTypes.number,
    batchSize: PropTypes.number,
    includePreferment: PropTypes.bool,
    recipeFlourTotalWeight: PropTypes.number,
    recipeLiquidTotalWeight: PropTypes.number,
    recipeStarterTotalWeight: PropTypes.number,
    recipeYeastTotalWeight: PropTypes.number,
    recipeMixinTotalWeight: PropTypes.number,
    recipeSoakerTotalWeight: PropTypes.number,
    recipeTotalWeight: PropTypes.number
  }),
  visible: PropTypes.bool
}

export { RecipeSummaryTable }